import { getUserNotifications } from './getUserNotifications'
import { readAllUserNotifications } from './readAllUserNotifications'
import { readUserNotification } from './readUserNotification'

export const notificationsService = {
  getUserNotifications,
  readAllUserNotifications,
  readUserNotification,
}
